/**
 * 接口地址统一来源（不走 devServer 代理 proxyTable）
 *
 * 取值优先级：
 * 1. 构建/启动时注入的 process.env.API_HOST（完整源，如 https://mgt.imagingedu.com）
 * 2. 自动取浏览器地址拼接：protocol//hostname[:API_PORT || 当前端口]
 *    - dev 环境默认注入 API_PORT=82（见 config/dev.env.js），即请求 http://<浏览器host>:82
 *    - 生产环境跟随页面端口，即同源直连
 */
function getApiOrigin () {
  const envHost = process.env.API_HOST
  if (envHost) {
    return envHost.replace(/\/+$/, '')
  }
  const { protocol, hostname, port } = window.location
  const apiPort = process.env.API_PORT || port
  return `${protocol}//${hostname}${apiPort ? ':' + apiPort : ''}`
}

export const API_ORIGIN = getApiOrigin()

/**
 * 拼接接口完整地址
 * @param {string} path 以 / 开头的接口路径，如 '/api/college_manage'
 */
export const getApiUrl = (path) => {
  return `${API_ORIGIN}${path.indexOf('/') === 0 ? path : '/' + path}`
}



// WEBPACK FOOTER //
// ./src/api/config/baseUrl.js